import React from 'react';
import { Formik } from 'formik';
import TextInput from '../../components/styled/TextInput';
import { ScrollView } from 'react-native';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import Text from '../../components/styled/Text';
import View from '../../components/styled/View';
import styles from './styles';
import { fanCreateProfileSchema } from './validationSchema';

export default function FanProfile({ navigation, route }) {
  const goToFanGenres = (values) => {
    navigation.navigate('FanGenres', {
      isCreate: true,
      formikValues: values,
    });
  };
  return (
    <ScrollView contentContainerStyle={{ flex: 1 }}>
      <View style={styles.container}>
        <Text style={styles.title} lightColor="00ff00">
          {' '}
          Create Your Profile
        </Text>
        <Formik
          initialValues={{ fullName: '', zipCode: '' }}
          onSubmit={(values) => goToFanGenres(values)}
          validationSchema={fanCreateProfileSchema}
        >
          {({
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            touched,
            values,
          }) => (
            <>
              <View>
                <TextInput
                  autoCapitalize="words"
                  autoCompleteType="name"
                  autoCorrect
                  errorMessage={touched.fullName && errors.fullName}
                  keyboardType="default"
                  label="Full Name*"
                  labelHidden
                  onBlur={handleBlur('fullName')}
                  onChangeText={handleChange('fullName')}
                  placeholder="Full Name"
                  value={values.fullName}
                />
                <TextInput
                  autoCompleteType="postal-code"
                  autoCapitalize="none"
                  errorMessage={touched.zipCode && errors.zipCode}
                  keyboardType="default"
                  label="zipcode"
                  labelHidden
                  onBlur={handleBlur('zipCode')}
                  onChangeText={handleChange('zipCode')}
                  placeholder="Zipcode"
                  value={values.zipCode}
                />
                <LinearGradientButton
                  disabled={!isValid}
                  title="Choose Genres"
                  onPress={handleSubmit}
                />
              </View>
            </>
          )}
        </Formik>
      </View>
    </ScrollView>
  );
}
